import { __decorate } from "tslib";
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { getConfig } from 'choerodon-ui/lib/configure';
import ObserverTextField from '../text-field/TextField';
import Form from '../form/Form';
import localeContext from '../locale-context';
let IntlList = class IntlList extends Component {
    renderOptions() {
        const { name, lang, maxLengths } = this.props;
        const { supports } = localeContext;
        const tlsKey = getConfig('tlsKey');
        return Object.keys(supports).map(key => {
            const maxLengthProps = maxLengths && maxLengths[key] ? { maxLength: maxLengths[key] } : {};
            return (React.createElement(ObserverTextField, Object.assign({}, maxLengthProps, { name: name ? `${tlsKey}.${name}.${key}` : key, autoFocus: key === lang, key: key })));
        });
    }
    render() {
        const { record, disabled, readOnly } = this.props;
        return React.createElement(Form, { disabled: disabled, readOnly: readOnly, record: record }, this.renderOptions());
    }
};
IntlList.propTypes = {
    record: PropTypes.object,
    name: PropTypes.string,
    lang: PropTypes.string,
    maxLengths: PropTypes.object,
};
IntlList = __decorate([
    observer
], IntlList);
export default IntlList;
